module.exports = __webpack_public_path__ + "static/media/image03.190e2d15.png";